<template>
  <v-container fluid class="pa-0">
    <v-card class="mr-3 ml-3 mb-3 pa-3">
      <v-card-title class="headline">Заказ Мастер-лицензии</v-card-title>

      <v-card-text>
        <v-form v-model="isValid">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="master.object"
                :items="choices.objects"
                :disabled="loading.objects"
                :loading="loading.objects"
                label="Объект"
                no-data-text="Объекты отсутствуют"
                :rules="[notEmptyRule]"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="master.module"
                :items="choices.modules"
                :disabled="loading.modules"
                :loading="loading.modules"
                label="Модуль"
                no-data-text="Модули отсутствуют"
                :rules="[notEmptyRule]"
                @change="(v) => changeModule(v)"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.description">
                      {{ item.description }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Доп. инфо"
                :value="selectedModuleDescription"
                readonly
                dense
                rows="1"
                auto-grow
                hide-details
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Дата окончания лицензии"
                disabled
                readonly
                v-model="expireDate"
                :loading="loading.expireDate"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-card class="mx-1" :loading="loading.features" :disabled="this.master.features == 0">
                <v-card-title class="pb-0">Управление фичами</v-card-title>
                <v-card-text>
                  <span v-if="master.module == null">Модуль не выбран</span>
                  <span v-else-if="this.master.features == 0">У модуля нет фичей</span>
                  <template v-else>
                    <v-checkbox
                      v-for="feature in master.features"
                      :key="feature.id"
                      v-model="feature.included"
                      :label="feature.name"
                      hide-details
                    ></v-checkbox>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-col cols="12">
            <v-textarea label="Комментарий"
              :rows="3"
              v-model="master.comment"
              hint="Тут вы можете указать любую дополнительную информацию по заявке"
              persistent-hint
              ></v-textarea>
          </v-col>
        </v-form>
      </v-card-text>
      <div class="d-flex mt-4">
        <v-spacer></v-spacer>
        <v-btn
          color="green"
          :dark="isValid"
          :disabled="!isValid"
          :loading="loading.create"
          @click="orderMaster"
        >
          Заказать
        </v-btn>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import API from "@/axios/api";
import {DUPLICATE_MASTER_SNACKBAR, objectHasMaster} from "@/utils/masters";

export default {
  name: 'MasterOrder',
  data() {
    return {
      loading: {
        objects: false,
        modules: false,
        moduleInfo: false,
        expireDate: false,
        create: false,
      },

      master: {
        object: null,
        module: null,
        features: [],
        comment: null,
      },
      choices: {
        modules: [],
        objects: [],
      },
      expireDate: null,
      isValid: false,
      notEmptyRule: v => !!v || 'Поле не может быть пустым',
    }
  },
  computed: {
    selectedModuleDescription() {
      if (!this.master.module) return '';
      const selected = this.choices.modules.find(m => m.value === this.master.module);
      return selected && selected.description ? selected.description : '';
    }
  },
  watch: {
    '$route.query.object'() {
      this.setObjectFromQuery()
    },
  },
  methods: {
    setObjectFromQuery() {
      const objectId = Number(this.$route.query.object)
      this.master.object = this.choices.objects.some(choice => choice.value === objectId) ? objectId : null
    },
    async changeModule(module) {
      this.master.features = []
      this.loading.features = true
      try {
        this.master.features = (await API.get(`modules/${module}/features/choices`)).data.choices
      } finally {
        this.loading.features = false
      }
    },
    async orderMaster() {
      this.loading.create = true
      try {
        if (await objectHasMaster(this.master.object, this.master.module)) {
          this.$store.dispatch("showSnackbar", DUPLICATE_MASTER_SNACKBAR)
          return
        }

        const response = await API.post('master_order/create', this.master)
        if (response.data.success) {
          if (response.data.msgIsSend) {
            this.$store.dispatch("showSnackbar", {
              color: "success",
              text: "Мастер-лицензия успешно создана",
            })
          } else {
            this.$store.dispatch("showSnackbar", {
              color: "warning",
              text: "Мастер-лицензии создана, но автоотправка письма не была успешной. Сообщите об этом нашей компании.",
            })
          }
          this.$store.dispatch('updateMasters')
          this.$router.push('/masters')
        } else {
          this.$store.dispatch("showSnackbar", DUPLICATE_MASTER_SNACKBAR)
        }
      } finally {
        this.loading.create = false
      }
    },
  },
  created() {
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "master_order", disabled: true },
    ]);
    this.loading.objects = true
    this.loading.expireDate = true
    this.loading.modules = true
    API.get('master_order/objects')
      .then((response) => {
        this.choices.objects = response.data.objects
        this.choices.objects.forEach(choice => choice.text += ` (${choice.value})`)
        this.setObjectFromQuery()
      })
      .finally(() => {
        this.loading.objects = false
      })

    API.get('master_order/expire_date')
      .then((response) => {
        this.expireDate = response.data.date
      })
      .finally(() => {
        this.loading.expireDate = false
      })
    
    API.get(`master_order/modules`)
      .then((response) => {
        this.choices.modules = response.data.modules
      })
      .finally(() => {
        this.loading.modules = false
      })
  }
}
</script>

<style>

</style>
